import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Canvas = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#a)">
        <rect width="9" height="9" x="3.5" y="3.5" stroke={color} rx=".5" />
        <rect width="9" height="9" x="3.5" y="-7.5" stroke={color} rx=".5" />
        <rect width="9" height="9" x="3.5" y="14.5" stroke={color} rx=".5" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default Canvas
